import { useState, useEffect } from 'react';

export const useSettings = () => {
  const [settings, setSettings] = useState({
    contact_email: 'DiveCampAdventures@gmail.com',
    contact_phone: '+61 414 710 541',
    whatsapp_number: '+61 414 710 541',
    business_hours: 'Daily: 6:00 AM - 8:00 PM',
    location: 'Sydney, NSW • Servicing Coastal NSW',
    abn: '14166004210',
    social_links: {
      instagram: '',
      facebook: '',
      youtube: '',
      tiktok: ''
    }
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings`);
      
      if (response.ok) {
        const data = await response.json();
        setSettings(prevSettings => ({
          ...prevSettings,
          ...data
        }));
      } else {
        console.warn('Failed to fetch settings, using defaults');
      }
    } catch (err) {
      console.error('Error fetching settings:', err);
      setError(err.message);
      // Continue with default settings on error
    } finally {
      setLoading(false);
    }
  };

  return { settings, loading, error, refetch: fetchSettings };
};